export function convertToThumbnailImageUrl(url: string, width: number): string {
  const updatedUrl = url.replace('static/file', 'static/file/thumbnail');
  return `${updatedUrl}?w=${width}`;
}
